import { requestStatusTypes } from "../info-technology-process/types";

export const getRequestStatusHasAssigneeOptions = (
  completedTypeLabel: string = "Xoá"
): Array<{ label: string; value: string }> => [
  { label: "Đang đợi thực thi", value: requestStatusTypes.submittedAssignee },
  { label: "Đang đợi duyệt", value: requestStatusTypes.submitted },
  { label: "Đã duyệt", value: requestStatusTypes.approved },
  { label: "Đang thực thi", value: requestStatusTypes.inProgress },
  { label: "Đã từ chối", value: requestStatusTypes.rejected },
  { label: completedTypeLabel, value: requestStatusTypes.completed },
];
